import { render } from "./App.vue?vue&type=template&id=746d8656"
const script = {}

import "./App.vue?vue&type=style&index=0&id=746d8656&lang=css"

import exportComponent from "/usr/local/www/sites/liveportrait_v2/other_sites/coldplay.liveportrait.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__